import { Breadcrumb, Button, Card, Form, Input, Modal, Select } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import Loader from "../../../components/loader";
import SettingsService from "../../../services/settings.service";
import CustomSlider from "../../../components/slider";
import CustomNumberInput from "../../../components/customNumberInput";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";

export default function TransferLimitDetails() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [isValueChanged, setValueChanged] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedAcc, setSelectedAcc] = useState("");
  const [form] = Form.useForm();
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [showModalVisible, setShowModalVisible] = useState(false);
  const [formData, setFormData] = useState([]);
  const [limits, setLimits] = useState({});
  const [txnDetails, setTxnDetails] = useState({
    impsLimit: 0,
    neftLimit: 0,
    rtgsLimit: 0,
    iatLimit: 0,
    upiLimit: 0,
  });

  useEffect(() => {
    if (location.state) {
      getCustomerTxnList(location.state);
    }
  }, []);

  const getCustomerTxnList = useCallback(async (data) => {
    try {
      setLoading(true);
      const response = await SettingsService.getCustomerTxnList();
      if (response.status === 200) {
        setLoading(false);
        setLimits(response.data);
        const acc = response.data["txnLimits"].find(
          (v) => v.accountNo === data.accountNo
        );
        form.setFieldsValue({
          accountNo: acc.accountNo,
          iatLimit: acc.iatLimit,
          impsLimit: acc.impsLimit,
          neftLimit: acc.neftLimit,
          rtgsLimit: acc.rtgsLimit,
        });
        setTxnDetails({ ...acc });
        setSelectedAcc(acc);
      }
    } catch (error) {
      setLoading(false);
    }
  }, []);

  const handleSliderChange = useCallback(
    (value, name) => {
      try {
        setValueChanged(true);
        setTxnDetails({ ...txnDetails, [name]: value });
        form.setFieldsValue({
          [name]: value,
        });
      } catch (error) {}
    },
    [txnDetails]
  );

  const updateTransactionLimit = useCallback(
    async (values) => {
      try {
        let request = {
          list: [
            {
              accountNo: selectedAcc?.accountNo,
              impsLimit:
                typeof values.impsLimit === "string"
                  ? Number(values.impsLimit.replace(/[^0-9]/g, ""))
                  : values.impsLimit || 0,
              neftLimit:
                typeof values.neftLimit === "string"
                  ? Number(values.neftLimit.replace(/[^0-9]/g, ""))
                  : values.neftLimit || 0,
              rtgsLimit:
                typeof values.rtgsLimit === "string"
                  ? Number(values.rtgsLimit.replace(/[^0-9]/g, ""))
                  : values.rtgsLimit || 0,
              iatLimit:
                typeof values.iatLimit === "string"
                  ? Number(values.iatLimit.replace(/[^0-9]/g, ""))
                  : values.iatLimit || 0,
              upiLimit: 0,
            },
          ],
        };
        setLoader(true);
        const response = await SettingsService.updateTransactionLimit(request);
        if (response.status === 200) {
          setMessage(response.data["message"]);
          setShowModal(true);
        }
        setLoader(false);
      } catch (error) {
        setLoader(false);
      }
    },
    [selectedAcc]
  );

  return (
    <>
      <div style={{ marginBottom: 20 }}>
        <Breadcrumb>
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/accounts")}>
              {" "}
              {t("pages.my_accounts.common_my_accounts.accounts", {
                defaultValue: "Accounts",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {" "}
              {t("pages.my_accounts.common_my_accounts.transfer_limits", {
                defaultValue: "Transfer Limits",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <div className="row">
        <div className="col-12 col-sm-12 col-md-8 col-lg-6">
          {loading && (
            <div>
              <Loader />
            </div>
          )}
          <Card className="card-slider application-card">
            <h4 className="primary-title">
              {t("pages.settings.transaction_limits", {
                defaultValue: "Transaction Limits",
              })}
            </h4>
            <h6>
              {" "}
              {t("pages.my_accounts.common_my_accounts.limit_txt", {
                defaultValue:
                  "You can now set customised limits for all your accounts",
              })}
            </h6>
            <p className="mb-3  mt-3">
              {t("pages.my_accounts.common_my_accounts.range_txt", {
                defaultValue:
                  "Once you set a limit, you will be able to transact only within that range. You can modify this at any time in the future",
              })}
            </p>

            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <Form
                  layout="vertical"
                  form={form}
                  onFinish={(e) => {
                    setShowModalVisible(true);
                    setFormData(e);
                  }}
                >
                  <div className="account-details mb-3">
                    <label>
                      {t("common.account_no_lbl", {
                        defaultValue: "Account Number",
                      })}
                    </label>

                    {selectedAcc?.accountNo}
                  </div>

                  <div className="row">
                    <div
                      className="col-12 col-sm-6 col-md-12 col-lg-7"
                      style={{ padding: "10px" }}
                    >
                      {t("pages.settings.within_bank_limit", {
                        defaultValue: "Within Bank limit",
                      })}
                    </div>
                    <div className="col-12 col-sm-6 col-md-5 col-lg-5">
                      <CustomNumberInput
                        name="iatLimit"
                        maxLimit={limits?.iatLimit}
                        prefix="₹"
                        onChange={(value) =>
                          handleSliderChange(value, "iatLimit")
                        }
                        disabled={
                          form.getFieldValue("iatLimit") <= 0 ||
                          form.getFieldValue("iatLimit") === ""
                        }
                      />
                    </div>
                  </div>
                  <CustomSlider
                    min={0}
                    max={limits?.iatLimit}
                    disabled={false}
                    value={txnDetails.iatLimit}
                    onChange={(value) => handleSliderChange(value, "iatLimit")}
                    className="mt-0"
                  />

                  <div className="row">
                    <div
                      className="col-12 col-sm-6 col-md-12 col-lg-7"
                      style={{ padding: "10px" }}
                    >
                      {t("pages.my_accounts.common_my_accounts.imps_limit", {
                        defaultValue: "IMPS limit",
                      })}
                    </div>
                    <div className="col-12 col-sm-6 col-md-5 col-lg-5">
                      <CustomNumberInput
                        name="impsLimit"
                        maxLimit={limits?.maxImpsLimit}
                        prefix="₹"
                        onChange={(value) =>
                          handleSliderChange(value, "impsLimit")
                        }
                        disabled={
                          form.getFieldValue("impsLimit") <= 0 ||
                          form.getFieldValue("impsLimit") === ""
                        }
                      />
                    </div>
                  </div>
                  <CustomSlider
                    min={0}
                    max={limits?.maxImpsLimit}
                    disabled={false}
                    value={txnDetails.impsLimit}
                    onChange={(value) => handleSliderChange(value, "impsLimit")}
                    className="mt-0"
                  />

                  <div className="row">
                    <div
                      className="col-12 col-sm-6 col-md-12 col-lg-7"
                      style={{ padding: "10px" }}
                    >
                      {t("pages.my_accounts.common_my_accounts.neft_limit", {
                        defaultValue: "NEFT limit",
                      })}
                    </div>
                    <div className="col-12 col-sm-6 col-md-5 col-lg-5">
                      <CustomNumberInput
                        name="neftLimit"
                        maxLimit={limits?.maxNeftLimit}
                        prefix="₹"
                        onChange={(value) =>
                          handleSliderChange(value, "neftLimit")
                        }
                        disabled={
                          form.getFieldValue("neftLimit") <= 0 ||
                          form.getFieldValue("neftLimit") === ""
                        }
                      />
                    </div>
                  </div>
                  <CustomSlider
                    min={0}
                    max={limits?.maxNeftLimit}
                    disabled={false}
                    value={txnDetails.neftLimit}
                    onChange={(value) => handleSliderChange(value, "neftLimit")}
                    className="mt-0"
                  />

                  <div className="row">
                    <div
                      className="col-12 col-sm-6 col-md-12 col-lg-7"
                      style={{ padding: "10px" }}
                    >
                      {t("pages.my_accounts.common_my_accounts.rtgs_limit", {
                        defaultValue: "RTGS limit",
                      })}
                    </div>
                    <div className="col-12 col-sm-6 col-md-5 col-lg-5">
                      <CustomNumberInput
                        name="rtgsLimit"
                        maxLimit={limits?.maxRtgsLimit}
                        prefix="₹"
                        onChange={(value) =>
                          handleSliderChange(value, "rtgsLimit")
                        }
                        disabled={
                          form.getFieldValue("rtgsLimit") <= 0 ||
                          form.getFieldValue("rtgsLimit") === ""
                        }
                      />
                    </div>
                  </div>
                  <CustomSlider
                    min={0}
                    max={limits?.maxRtgsLimit}
                    disabled={false}
                    value={txnDetails.rtgsLimit}
                    onChange={(value) => handleSliderChange(value, "rtgsLimit")}
                    className="mt-0"
                  />

                  <Button
                    style={{
                      backgroundColor: isValueChanged ? "#15c7a5" : "white",
                      color: isValueChanged && "white",
                    }}
                    block
                    size="large"
                    className="solid-btn-style"
                    htmlType="submit"
                    loading={loader}
                    disabled={!isValueChanged}
                    type="primary"
                  >
                    {t("buttons.save_btn", {
                      defaultValue: "Save",
                    })}
                  </Button>
                </Form>
              </div>
            </div>
          </Card>
        </div>
        <Modal
          title={t("pages.transfer_limit.transfer_limit", {
            defaultValue: "Transfer Limit",
          })}
          open={showModal}
          footer={null}
          width={350}
          closable={false}
          maskClosable={false}
          mask={true}
        >
          <p style={{ marginBottom: 30, fontSize: 15 }}>{message}</p>
          <div align="right" className="mt-3">
            <Button
              type="link"
              onClick={() => {
                setShowModal(false);
                navigate("/dashboard");
              }}
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </Modal>
        <Modal
          title={"Save changes ?"}
          open={showModalVisible}
          footer={null}
          width={350}
          closable={false}
          maskClosable={false}
          mask={false}
        >
          <p style={{ marginBottom: 30, fontSize: 15 }}>
            {t("pages.transfer_limit.transaction_msg", {
              defaultValue:
                "Would you like to save the changes to transaction limits ?",
            })}
          </p>
          <div className="mt-3" align="right">
            <Button
              type="default"
              onClick={() => {
                setShowModalVisible(false);
              }}
            >
              {t("buttons.ignore_btn", {
                defaultValue: "Ignore",
              })}
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 20 }}
              onClick={() => {
                setShowModalVisible(false);
                updateTransactionLimit(formData);
              }}
            >
              {t("buttons.save_btn", {
                defaultValue: "Save",
              })}
            </Button>
          </div>
        </Modal>
      </div>
    </>
  );
}
